import { createMigrate } from "redux-persist";

import { migration20250323 } from "./20250323_cleanStructures";
import { migration20260730UserScopedReactions } from "./20260730_userScopedReactions";

export const createMigrations = createMigrate(
    {
        0: migration20250323,
        1: migration20260730UserScopedReactions,
    },
    { debug: false }
);
